"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuth = void 0;
const specific_entity_1 = require("../../abstracts/specific-entity");
const config_1 = require("../../shared/config");
const auth_context_helper_1 = require("./auth-context-helper");
class OAuth extends specific_entity_1.SpecificEntity {
    constructor(parentEntity, debug = false) {
        super(parentEntity.id, parentEntity, debug);
        this.BASE_URLS = {
            'PROD': 'https://auth.nblocks.cloud',
            'STAGE': 'https://auth-stage.nblocks.cloud',
            'DEV': 'http://localhost:3070'
        };
        this.contextHelper = new auth_context_helper_1.AuthContextHelper(parentEntity, debug);
    }
    /** Get entrypoint to the login flow. Redirect your user to this url */
    getLoginUrl(options) {
        const params = options ? new URLSearchParams(options) : undefined;
        return `${this._getBaseUrl()}/url/login/${this.id}${!!params ? '?' + params.toString() : ''}`;
    }
    /** Get url to the logout flow. Redirect your user to this url to completely logout the session */
    getLogoutUrl(options) {
        const params = options ? new URLSearchParams(options) : undefined;
        return `${this._getBaseUrl()}/url/logout/${this.id}${!!params ? '?' + params.toString() : ''}`;
    }
    async getHandoverCode(accessToken) {
        // Throws valuable information if accessToken is not valid
        await this.contextHelper.getAuthContextVerified(accessToken);
        const body = { accessToken };
        const response = await this.getHttpClient().post(`/handover/code/${this.id}`, body, { baseURL: this._getBaseUrl() });
        return response.data;
    }
    async getTokensAndVerify(code, options) {
        const tokens = await this._getTokens(code, options);
        const [authContext, profile] = await Promise.all([
            this.contextHelper.getAuthContextVerified(tokens.access_token),
            tokens.id_token ? this.contextHelper.getProfileVerified(tokens.id_token) : Promise.resolve(undefined),
        ]);
        return { tokens, authContext, profile };
    }
    async _getTokens(code, options) {
        const body = { ...options, code };
        const response = await this.getHttpClient().post(`/token/code/${this.id}`, body, { baseURL: this._getBaseUrl() });
        return response.data;
    }
    async refreshTokensAndVerify(refreshToken) {
        const tokens = await this._refreshTokens(refreshToken);
        const authContext = await this.contextHelper.getAuthContextVerified(tokens.access_token);
        return { tokens, authContext };
    }
    async _refreshTokens(refreshToken) {
        const response = await this.getHttpClient().post(`/token/refresh/${this.id}`, { refreshToken }, { baseURL: this._getBaseUrl() });
        return response.data;
    }
    /**
     * Gets the base url by fetching current stage from Platform
     * @returns
     */
    _getBaseUrl() {
        return config_1.ConfigHelper.getEnvVariable("NBLOCKS_AUTH_API_URL") || this.BASE_URLS[this.getPlatformClient().stage];
    }
}
exports.OAuth = OAuth;
